class MainNav extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }
  
    init() {
      this.appendNavImages();
    }
  
    appendNavImages() {
      const images = this.querySelectorAll('[data-nav-image]');
      const navData = this.querySelector('[nav-data-set]');
      images.forEach(image => {
        const imgSrc = navData.getAttribute(image.dataset.navImage);
        if (imgSrc) {
          image.src = imgSrc;
          image.previousSibling?.classList?.add('hidden');
        } else {
          image.classList.add('hidden');
        }
      })
    }
  }
  
  customElements.define('main-nav', MainNav);